import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowUp, FaTiktok, FaFacebookF, FaLinkedinIn, FaGoogle } from 'react-icons/fa';
import logo from 'assets/images/logo.png';

const LINKS = [
  { label: 'Features',      to: '/#features' },
  { label: 'Integrations',  to: '/#integrations' },
  { label: 'How it works',  to: '/#how-it-works' },
  { label: 'Testimonials',  to: '/#testimonials' },
  { label: 'Pricing',       to: '/#pricing' },
];

const PLATFORMS = [
  { icon: <FaTiktok />,    name: 'TikTok' },
  { icon: <FaFacebookF />, name: 'Meta' },
  { icon: <FaLinkedinIn />,name: 'LinkedIn' },
  { icon: <FaGoogle />,    name: 'Google' },
  { icon: <span style={{ fontSize: 14 }}>👻</span>, name: 'Snapchat' },
  { icon: <span style={{ display: 'inline-flex', width: 14, height: 14, borderRadius: 3, background: '#1862D9', color: '#fff', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: 900, fontFamily: 'Georgia,serif' }}>t</span>, name: 'Taboola' },
];

const Footer = () => {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <footer style={{ background: '#0F0B2D', borderTop: '1px solid rgba(255,255,255,0.08)', padding: '56px 24px 28px' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>

        {/* Top row */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px,1fr))', gap: 40, marginBottom: 48 }}>

          {/* Brand */}
          <div>
            <div style={{ background: '#fff', display: 'inline-flex', borderRadius: 8, padding: '6px 10px', marginBottom: 14 }}>
              <img src={logo} alt="OneBotAds" style={{ height: 28 }} />
            </div>
            <p style={{ fontSize: 13.5, color: 'rgba(255,255,255,0.4)', lineHeight: 1.7, maxWidth: 220 }}>
              One platform to manage all your digital ad campaigns, powered by AI.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <div style={{ fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.3)', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: 16 }}>Platform</div>
            {LINKS.map(l => (
              <a key={l.label} href={l.to} style={{ display: 'block', fontSize: 14, color: 'rgba(255,255,255,0.5)', textDecoration: 'none', marginBottom: 10, transition: 'color 0.15s' }}
                onMouseEnter={e => e.target.style.color = '#fff'}
                onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.5)'}
              >{l.label}</a>
            ))}
          </div>

          {/* Account */}
          <div>
            <div style={{ fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.3)', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: 16 }}>Account</div>
            {[{ label: 'Log in', to: '/login' }, { label: 'Sign up', to: '/signup' }].map(l => (
              <Link key={l.label} to={l.to} style={{ display: 'block', fontSize: 14, color: 'rgba(255,255,255,0.5)', textDecoration: 'none', marginBottom: 10, transition: 'color 0.15s' }}
                onMouseEnter={e => e.target.style.color = '#fff'}
                onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.5)'}
              >{l.label}</Link>
            ))}
          </div>

          {/* Platforms */}
          <div>
            <div style={{ fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.3)', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: 16 }}>Supported Platforms</div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
              {PLATFORMS.map((p, i) => (
                <span key={i} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '5px 12px', borderRadius: 8, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.08)', fontSize: 12, color: 'rgba(255,255,255,0.5)' }}>
                  {p.icon} {p.name}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Divider */}
        <div style={{ height: 1, background: 'rgba(255,255,255,0.06)', marginBottom: 24 }} />

        {/* Bottom row */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
          <span style={{ fontSize: 13, color: 'rgba(255,255,255,0.25)' }}>© 2026 ONEBOTADS. All rights reserved.</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            <Link to="/privacy-policy" style={{ fontSize: 13, color: 'rgba(255,255,255,0.5)', textDecoration: 'none' }}>Privacy</Link>
            <Link to="/terms-of-service" style={{ fontSize: 13, color: 'rgba(255,255,255,0.5)', textDecoration: 'none' }}>Terms</Link>
          </div>
          <button onClick={scrollToTop} aria-label="Back to top" style={{
            width: 36, height: 36, borderRadius: '50%',
            background: 'rgba(255,255,255,0.07)',
            border: '1px solid rgba(255,255,255,0.12)',
            color: 'rgba(255,255,255,0.6)', cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            transition: 'all 0.2s',
          }}
            onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.15)'; e.currentTarget.style.color = '#fff'; }}
            onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.07)'; e.currentTarget.style.color = 'rgba(255,255,255,0.6)'; }}
          >
            <FaArrowUp style={{ fontSize: 12 }} />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
